<template>
  <div class="home">
    <header-model @mddw="mddw" />
    <!-- banner图 -->
    <div class="banner" style="position: relative">
      <el-carousel
        :interval="2000"
        arrow="always"
        height="6rem"
        setActiveItem="setvalue"
        @change="bannerchange"
        class="banner1"
      >
        <el-carousel-item v-for="(item, index) in banList" :key="index">
          <img
            :src="item.pc_image"
            alt="加载中"
            style="width: 100%; height: 6rem"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 关于我们 -->
    <div class="main1 centent" id="gywm">
      <div class="main1_title">关于我们</div>
      <div class="main1_sm">
        专注应急管理，提供线上+线下的整体培训解决方案，让安全培训更加普及和高效
      </div>
      <div class="flexs">
        <div class="main1_left">
          湖北尚安思德
          <div></div>
        </div>
        <div class="main1_right">
          <p>
            我要安全在线培训平台由湖北尚安思德科技有限公司自主研发设计，为安全应急培训和
            职业技能培训提供高质量的课程、先进的技术平台和完善的服务，用专业的资源和先进的在
            线教育理念，结合移动互联技术，提供质量的课程、先进的技术平台和完善的服务，用专业的资源和先进的在
            线教育理念，结合移动互联技术，提供“线上+线下”相结合的整体培训解决方案。
          </p>
          <p style="margin-top: 0.4rem">
            我要安全秉承“科学赋能教育，学习点燃梦想”的理念，致力于“互联网+”发展战略，
            专注于应急管理和技能提升领域移动互联网产品的研制和服务，先后拥有多项安全培训著作
            权及相关专利权证书，能够自主研发线下线上，软硬结合的培训产品，以及与之相配套的服
            务体系。
            公司坚持以核心科技和数据技术双驱动，助力服务全国上亿产业从业人员及普通公
            众安全培训、技能提升培训和应急知识普及教育，致力于成为国内安全应急、技能提升教培领
            域的领先企业。
          </p>
        </div>
      </div>
    </div>
    <!-- 新闻资讯 -->
    <div class="new_max">
      <div class="new_main1 centent">
        <div class="main1_title">新闻资讯</div>
        <div class="main1_sm">以创新科技，让生命更安全！</div>
        <div class="flexs">
          <div class="main2_left">
            <img src="../assets/img/news01.png" alt="" />
            <div class="new_title">
              中国职业安全健康协会与湖北尚安思德科技有限公司签署战略合作协议
            </div>
          </div>
          <div class="main2_right" v-if="newList.length > 0">
            <div>
              <div class="flexs new_item">
                <div class="new_item_left">
                  <div>{{ newList[0].title }}</div>
                  <div class="new_item_div">
                    {{ newList[0].description }}
                  </div>
                  <div @click="$commonData.toPage('/newpage')">了解更多></div>
                </div>
                <div class="new_item_right">
                  <div>
                    <div>
                      {{ newList[0].createtime.slice(5, 7) }}月{{
                        newList[0].createtime.slice(8, 11)
                      }}日
                    </div>
                    <div class="time_rq">
                      {{ newList[0].createtime.slice(0, 4) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="padding: 0.2rem; box-sizing: border-box">
              <div
                class="flexs new_item1"
                @click="
                  $commonData.toPage('/newsDetail', {
                    id: item.id,
                    title: '行业动态',
                  })
                "
                v-for="(item, index) in newList.slice(1, 4)"
                :key="index"
              >
                <div class="new_item_left_pt">
                  <div class="new_item_title">
                    {{ item.title }}
                  </div>
                </div>
                <div class="new_item_right">
                  <div>{{ item.createtime }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btngd" @click="$commonData.toPage('/newpage')">
          更多资讯>
        </div>
      </div>
    </div>
    <!-- 课程优势 -->
    <div class="main1 centent" id="kcys">
      <div class="main1_title">课程优势</div>
      <div class="main1_sm">
        <p>
          课程采用模块化设计理念和数字化制作方法，涵盖煤矿及非煤矿山、金属冶炼、烟花爆竹、危险化学品、建筑施工、道路交通、冶金、有色、建材、
          机械、轻工、纺织、商贸、烟草等行业，同时拥有人社部门工伤预防培训和技能提升主要工种。
        </p>
      </div>
      <div class="clearfix" style="ke_item_max">
        <div
          class="ke_item fl"
          ref="keitem1"
        >
          <img
            src="../assets/img/sz.png"
            alt="加载中"
            :class="{ centesty: kenum != 1 }"
          />
          <div class="ke_ttile">师资雄厚</div>
          <p
            v-show="kenum == 1"
            style="
              font-size: 0.16rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              color: white;
            "
          >
            我们的师资力量专业、雄厚、具有权威性；讲师队伍
            也随着课程开发和升级的过程不断壮大。
          </p>
        </div>
        <div
          class="ke_item fl"
          ref="keitem2"
          :class="{ centesty: kenum != 2 }"
        >
          <img
            src="../assets/img/zy.png"
            alt="加载中"
            :class="{ centesty: kenum != 2 }"
          />
          <div class="ke_ttile">专业严谨</div>
          <p
            v-show="kenum == 2"
            style="
              font-size: 0.16rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              color: white;
            "
          >
            我们的师资力量专业、雄厚、具有权威性；讲师队伍
            也随着课程开发和升级的过程不断壮大。
          </p>
        </div>
        <div
          class="ke_item fl"
          ref="keitem3"
          :class="{ centesty: kenum != 3 }"
        >
          <img
            src="../assets/img/zl.png"
            alt="加载中"
            :class="{ centesty: kenum != 3 }"
          />
          <div class="ke_ttile">质量保证</div>
          <p
            v-show="kenum == 3"
            style="
              font-size: 0.16rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              color: white;
            "
          >
            我们的师资力量专业、雄厚、具有权威性；讲师队伍
            也随着课程开发和升级的过程不断壮大。
          </p>
        </div>
        <div
          class="ke_item fl"
          ref="keitem4"
          :class="{ centesty: kenum != 4 }"
        >
          <img
            src="../assets/img/kc.png"
            alt="加载中"
            :class="{ centesty: kenum != 4 }"
          />
          <div class="ke_ttile">课程形式多样</div>
          <p
            v-show="kenum == 4"
            style="
              font-size: 0.16rem;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              color: white;
            "
          >
            我们的师资力量专业、雄厚、具有权威性；讲师队伍
            也随着课程开发和升级的过程不断壮大。
          </p>
        </div>
      </div>
      <div class="btngd1">了解更多></div>
    </div>
    <!-- 平台功能 -->
    <div class="new_max1" id="ptgn">
      <div class="new_main1 centent">
        <div class="main1_title">平台功能</div>
        <div class="pt_btn">
          <button
            class="btn1"
            style="margin-left: 0.4rem"
            @mouseover="btncmouseover(1)"
            :class="{ btn: btnflag == 1 }"
          >
            <img
              src="../assets/img/phone1.png"
              alt="加载中"
              class="btn_img"
              v-if="btnflag != 1"
            />

            <img
              src="../assets/img/phone.png"
              alt="加载中"
              class="btn_img"
              v-else
            />
            <span class="btn_span">学员端</span>
          </button>
          <button
            class="btn1"
            style="margin-left: 0.4rem"
            @mouseover="btncmouseover(2)"
            :class="{ btn: btnflag == 2 }"
          >
            <img
              src="../assets/img/pc1.png"
              alt="加载中"
              class="btn_img1"
              v-if="btnflag == 2"
            />

            <img
              src="../assets/img/pc.png"
              alt="加载中"
              class="btn_img1"
              v-else
            />
            <span class="btn_span">管理端</span>
          </button>
        </div>
        <div class="main1_msg">
          基于“互联网+培训”理念推出的移动线上培训产品，定位于安全培训和技能提升培训好帮手，专注安全生产和职业技能提升培训领域。
        </div>
        <div class="flexs" v-show="btnflag == 1">
          <div class="pt_left">
            <img src="../assets/img/img06.png" alt="加载中" />
          </div>
          <div class="pt_right clearfix">
            <div class="flexs fl" v-for="(item, index) in 4" :key="index">
              <div class="pt_right_title">01</div>
              <div>
                <div class="pt_right_title">功能全面性</div>
                <div class="pt_item_p">
                  资源充足、教务管理、BI报表在线学习、操作明确、权限完善
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--管理端 -->
        <div v-show="btnflag == 2" class="flexs gld">
          <div class="gld_item gld_item_left">
            <div style="margin-bottom: 0.7rem">
              <div style="margin-bottom: 0.1rem">
                <img
                  src="../assets/img/gld1.png"
                  alt="加载中"
                  class="gld_item_img"
                />
                <span class="gld_item_span">支持多种题型</span>
              </div>
              <div class="gld_item_p">
                单选、多选、判断、案例分析题，自动化组卷阅卷
              </div>
            </div>
            <div>
              <div style="margin-bottom: 0.1rem">
                <img
                  src="../assets/img/gld2.png"
                  alt="加载中"
                  class="gld_item_img"
                />
                <span class="gld_item_span">多种练习方式</span>
              </div>
              <div class="gld_item_p">
                章节练习、模拟考试，精选题库，助力学员轻松取证
              </div>
            </div>
          </div>
          <div>
            <img src="../assets/img/gld.png" alt="加载中" class="gld_img" />
          </div>
          <div class="gld_item gld_item_right">
            <div style="margin-bottom: 0.7rem">
              <div style="margin-bottom: 0.1rem">
                <img
                  src="../assets/img/gld3.png"
                  alt="加载中"
                  class="gld_item_img"
                />
                <span class="gld_item_span">错题收藏</span>
              </div>
              <div class="gld_item_p">模拟考试错题实时记录，学 员重点复习</div>
            </div>
            <div>
              <div style="margin-bottom: 0.1rem">
                <img
                  src="../assets/img/gld2.png"
                  alt="加载中"
                  class="gld_item_img"
                />
                <span class="gld_item_span">答题统计</span>
              </div>
              <div class="gld_item_p">
                实时统计章节练习正确率， 分析考试成绩趋势
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品体系 -->
    <div class="main3 centent" id="cptx">
      <div class="main3_title">产品体系</div>
      <ul>
        <li>
          <div class="main3_img">
            <!-- <img src="../assets/img/dbx.png" alt="加载中" /> -->
            <div class="main3_text">学</div>
          </div>
          <div class="main3_item_title">学习体系</div>
          <p>线上安全生产培训实时建立培训档案</p>
        </li>
        <li>
          <div class="main3_img">
            <!-- <img src="../assets/img/dbx.png" alt="加载中" /> -->
            <div class="main3_text">考</div>
          </div>
          <div class="main3_item_title">考试体系</div>
          <p>每日一题、每周一练 每月一考，全方位安全生产培训</p>
        </li>
        <li>
          <div class="main3_img">
            <!-- <img src="../assets/img/dbx.png" alt="加载中" /> -->
            <div class="main3_text">管</div>
          </div>
          <div class="main3_item_title">监管体系</div>
          <p>配备账号管理端培训数据一目了然</p>
        </li>
        <li>
          <div class="main3_img">
            <!-- <img src="../assets/img/dbx.png" alt="加载中" /> -->
            <div class="main3_text">评</div>
          </div>
          <div class="main3_item_title">评估体系</div>
          <p>年度企业和员工AI智能安全生产体检报告</p>
        </li>
      </ul>
    </div>
    <!-- 课程展示 -->
    <div class="main4 centent">
      <div class="main4_title">课程展示</div>
      <div class="clearfix" style="width: 100%">
        <div v-for="(item, index) in 6" :key="index" class="fl main4_item">
          <img src="../assets/img/tc.png" alt="加载中" />
        </div>
      </div>
    </div>
    <footer-model />
    <el-backtop>
      <div
        style="
           {
            height: 100%;
            width: 100%;
            background-color: #f2f5f6;
            box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
            text-align: center;
            line-height: 40px;
            color: #666;
            font-weight: 900;
          }
        "
      >
        <i class="el-icon-arrow-up"></i>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import headerModel from "@/components/header.vue";
import footerModel from "@/components/footer.vue";
export default {
  name: "HomeView",
  data() {
    return {
      MaxWidth: "",
      btnflag: 1,
      setvalue: 0,
      showFlag: false,
      navnum: 0,
      mlurl: "",
      kenum: 1,
      banList: [],
      newList: [],
    };
  },
  components: { headerModel, footerModel },
  mounted() {
    document.title = "首页";
    if (this.$route.query.data && this.$route.query.data.flagtz) {
      this.mddw(this.$route.query.data.index);
    }
    this.getBanner();
    this.getnew();
  },
  methods: {
    mddw(num) {
      if (num == 1) {
        document.querySelector("#gywm").scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });
      }
      if (num == 2) {
        document.querySelector("#kcys").scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });
      }
      if (num == 3) {
        document.querySelector("#ptgn").scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });
      }
      if (num == 4) {
        document.querySelector("#cptx").scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });
      }
    },
    // 超出省略号
    fontNumber2(date) {
      const length = date.length;
      if (length > 80) {
        var str = "";
        str = date.substring(0, 80) + "......";
        return str;
      } else {
        return date;
      }
    },
    // 获取新闻列表页
    getnew() {
      this.newList = [];
      this.$http.get(this.$api + "/api/news/news_list").then((res) => {
        this.newList = res.data.data.data;
        this.newList[0].description = this.fontNumber2(
          this.newList[0].description
        );
      });
    },
    // 获取首页banner图数据
    getBanner() {
      this.banList = [];
      this.$http
        .get(this.$api + "/api/news/nav_img_list?type=1")
        .then((res) => {
          this.banList = res.data.data;
        });
    },
    bannerchange(e) {
      this.setvalue = e;
    },
    nextImg(num) {
      if (num == 1) {
        this.setvalue--;
        if (this.setvalue < 0) {
          this.setvalue = 2;
        }
      }
      if (num == 2) {
        this.setvalue++;
        if (this.setvalue == 3) {
          console.log(this.setvalue);
          this.setvalue = 0;
        }
      }
    },
    btncmouseover(num) {
      this.btnflag = num;
    },
    kcmouseover(str, num) {
      this.$refs["keitem1"].style.width = "17%";
      this.$refs["keitem2"].style.width = "17%";
      this.$refs["keitem3"].style.width = "17%";
      this.$refs["keitem4"].style.width = "17%";
      this.$refs[
        "keitem1"
      ].style.backgroundImage = `url('${this.$api}/image/news1.png')`;
      this.$refs[
        "keitem2"
      ].style.backgroundImage = `url('${this.$api}/image/news2.png')`;
      this.$refs[
        "keitem3"
      ].style.backgroundImage = `url('${this.$api}/image/news3.png')`;
      this.$refs[
        "keitem4"
      ].style.backgroundImage = `url('${this.$api}/image/news4.png')`;
      this.$refs[str].style.width = "40%";
      this.$refs[
        str
      ].style.backgroundImage = `url('${this.$api}/image/news${num}-1.png')`;
      this.kenum = num;
    },
  },
};
</script>
<style  src='../assets/css/home.css'>
</style>
